<template>
  <div class="w100 Contenido">
    <ModalNuevoRegistroVeris ref="Modal" v-show="ModalVisible" @Cerrar="CerrarModal" />
    <Titulo
      seccion="Informes de Ambientación"
      icon="images"
      :productor="NombreProductor()"
      :establecimiento="NombreEstablecimiento()"
    />
    <Descripcion>
      {{ Herramientas.Veris.description }}
    </Descripcion>

    <div class="DivInfoData" v-bind:class="{ 'Visible': !DataActualizada }" ref="DivInfoData">
      <div class="fLeft">
        Info recuperada de fecha: <span ref="FechaData"></span>
      </div>


      <div class="fRight" v-on:click.stop="RefrescarInfo(InfoVeris._IdVeris)">
        <font-awesome-icon  icon="sync-alt" size="4x" :style="{ color: 'white'}"  class="IconoActualizar fLeft"/>
        <!-- Actualizar -->
        <div class="clear"></div>
      </div>

      <div class="clear"></div>
    </div>

    <table>
      <thead>
        <tr>
          <th class="c1">Valor</th>
          <th>Fecha</th>
          <th class="pR c3">
            <font-awesome-icon
            v-on:click.stop="NuevoRegistro()"
            v-show="this.$parent.Datos.AdminLogueado()"
            icon="plus-circle" size="4x" :style="{ color: '#005625'}" class="IconoAgregar Centro"/>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(p, index) in RegistrosPag" :key="index">
          <td class="c1">
            <span @click="VerReportePDF(p)">
              <u>Ver Reporte</u>
            </span>
          </td>
          <td>{{ p._FechaAlta }}</td>
          <td class="c3">
            <font-awesome-icon
              v-show="p._Id > 0 && AdminLogueado() && Online()"
              v-on:click.stop="EliminarRegistro(p._Id, InfoVeris._IdVeris)"
              icon="trash-alt"
              size="4x"
              :style="{ color: '#934141' }"
              class="h100 IconoEliminar cP"
            />
            <font-awesome-icon
              v-show="p._Id <= 0"
              icon="spinner"
              size="4x"
              :style="{ color: '#000000' }"
              class="h100 IconoEliminar cP fa fa-spinner fa-spin"
            />
            <font-awesome-icon
              v-show="p._Id > 0 && AdminLogueado() && Online()"
              v-on:click.stop="DownloadPDF(p)"
              icon="download"
              size="4x"
              :style="{ color: '#444' }"
              class="h100 IconoEliminar cP"
            />
          </td>
        </tr>
      </tbody>
      <tbody></tbody>
    </table>

    <div class="SinRegistros" v-show="this.MostrarSinRegistros">
      Aún no hay registros...
    </div>

    <SlidingPagination
      v-show="totalPages > 1"
      :slidingEndingSize="2"
      :slidingWindowSize="2"
      :current="currentPage"
      :total="totalPages"
      @page-change="CambioDePagina"
    ></SlidingPagination>

    <div class="TituloPDF" ref="TituloPDF"></div>
    <pdf v-for="i in NumPagesPDF" :key="i" :page="i" :src="SrcPDF" ></pdf>

    <br /><br />
    <!-- <BotonVerMapa route="/vermapa" /> -->
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import SlidingPagination from "vue-sliding-pagination";
import ModalNuevoRegistroVeris from '../../components/Utilidades/ModalNuevoRegistroVeris';
import axios from "axios";
import Clases from "../../Auxiliares/Clases.js";
import ManejoDatos from "../../Auxiliares/ManejoDatos.js";
import { Herramientas } from "../../Auxiliares/Enums";

export default {
  name: "Veris",
  data() {
    return {
      Herramientas,
      SrcPDF: "",
      NumPagesPDF: 0,
      InfoVeris: null,
      RegistrosPag: [],
      MostrarSinRegistros: false,
      Inactivo: false,
      DataActualizada: true,
      _UserOk: false,
      Error: null,
      ModalVisible: false,
      //Paginado
      currentPage: 0,
      totalPages: 0,
      ItemsPorPagina: 5,
      RecalcularPaginado(_InfoVeris) {
        this.RegistrosPag = [];
        this.totalPages = Math.ceil(
          _InfoVeris._Registros.length / this.ItemsPorPagina
        );

        var _Aux = [];
        for (let i = 0; i < _InfoVeris._Registros.length; i++) {
          if (i >= (this.currentPage - 1) * this.ItemsPorPagina) {
            if (i < this.currentPage * this.ItemsPorPagina) {
              _Aux.push(_InfoVeris._Registros[i]);
            }
          }
        }
        this.RegistrosPag = _Aux;
        this.MostrarSinRegistros = this.RegistrosPag.length <= 0;
      },
      Online(){
        return this.$parent.Datos.AppOnline();
      },
      NombreProductor(){
        if (this.InfoVeris != null){
          return this.InfoVeris._Productor;
        }
        return "";
      },
      NombreEstablecimiento(){
        if (this.InfoVeris != null){
          return this.InfoVeris._Establecimiento;
        }
        return "";
      },
      AdminLogueado(){
        return this.$parent.Datos.AdminLogueado();
      },
      VerReportePDF(p){
      console.log(this.urlPosts + '/'+ p._Valor);
        this.SrcPDF = pdf.createLoadingTask(this.urlPosts + '/'+ p._Valor);
        this.$refs.TituloPDF.innerHTML = "PDF cargado en fecha: " + p._FechaAlta;
        var _This = this;
        this.SrcPDF.promise.then(pdf => {
          this.NumPagesPDF = pdf.numPages;
        })
        .catch((error) => {
          _This.$parent.Notificacion("Error!", "Podrás acceder al PDF cuando recuperes el internet...", "error", 3);
        });
      },
      DownloadPDF(_Registro) {
        var _UrlAbsoluta = this.urlPosts + '/'+ _Registro._Valor;


        var _NombreArchivo = "ReporteVeris-"
            + this.InfoVeris._Productor
            + "-" + this.InfoVeris._Establecimiento
            + "-" + _Registro._FechaAlta;

        _NombreArchivo = _NombreArchivo.LimpiarCaracteresInvalidos();

        var _This = this;
        ManejoDatos.DescargarArchivo(_UrlAbsoluta)
          .then (response => {
              const type = response.headers['content-type']
              const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
              const link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = _NombreArchivo + ".pdf"
              link.click()
          }).catch((err) => {
            _This.$parent.Notificacion("Parece que no tienes conexión", "Intenta más tarde!", "error", 3);
          })
      }
    };
  },
  mounted() {
    this._UserOk = this.$parent.Datos.ChequearSesionUsuario(this.$router);
    // TODO: (!) Revisar este tema del log. Quizas pueda hacerse un middle o plugin para que se chequée antes que todo.
    // Los mounted se disparan de abajo hacia arriba (el último en dispararse es el del App.vue)
    if (this._UserOk) {
      this.RefrescarInfo(this.$route.params.Id);
      this.SetearPDFInicial();
    }
  },
  methods: {
    SetearPDFInicial(){
      var _This = this;
      setTimeout(() => {
        if(_This.RegistrosPag.length > 0){
          _This.VerReportePDF(_This.RegistrosPag[0]);
          this.$refs.TituloPDF.innerHTML = "Último PDF cargado. Fecha: " + _This.RegistrosPag[0]._FechaAlta;
        }
      }, 1000);
    },
    RefrescarInfo(_Id){
      if(this.VistaActual(_Id)){
        this.IntentoObtenerDataDeCache(_Id);
      }
      ManejoDatos.ObtenerRegistrosVeris(_Id, this);
    },
    VistaActual(_Id){
      return (this.$route.params.Id == _Id && this.$route.name == "Veri");
    },
    AuxiliaresVista(_Id){
      if(this.VistaActual(_Id)){
        this.currentPage = 1;
        //this.AgregarPendientes();
        this.RecalcularPaginado(this.InfoVeris);
      }
    },
    AgregarPendientes(){
      var _Pendientes = Clases.RecuperarJsonDeStorage(this.KeyRegistrosPendientes());
      if(_Pendientes != null){
        _Pendientes.forEach(_Reg => {
          var _Reg = {
            _Id: 0,
            _Valor: _Reg.Valor,
            _FechaAlta: new Clases.Fecha()._Fecha
          };
          this.InfoVeris._Registros.unshift(_Reg);
        });
      }
    },
    IntentoObtenerDataDeCache(_Id){
      try {
        var _Data = Clases.RecuperarJsonDeStorage(this.KeyDataCacheada(_Id));
        if (_Data != null){
          this.InfoVeris = _Data._Json;
          this.$refs.FechaData.innerHTML = _Data._Fecha._FechaYHora;
        }
      } catch (e) {
        console.log(e);
      }
    },
    GuardarDataEnCache(_InfoAGuardar){
      var _Data = {
        _Fecha: new Clases.Fecha(new Date()),
        _Key: this.KeyDataCacheada(_InfoAGuardar._IdVeris),
        _Json: _InfoAGuardar
      };
      Clases.GuardarJsonEnStorage(this.KeyDataCacheada(_InfoAGuardar._IdVeris), _Data);
    },
    KeyDataCacheada(_Id){
      return "InfoVeris" + _Id;
    },
    /** RegistrosPendientes_*/
    KeyRegistrosPendientesGeneral(){
      return "RegistrosPluviometroPendientes_";
    },
    KeyRegistrosPendientes(){
      return this.KeyRegistrosPendientesGeneral() + this.$route.params.Id;
    },
    CambioDePagina(selectedPage) {
      this.currentPage = selectedPage;
      this.RecalcularPaginado(this.InfoVeris);
    },
    NuevoRegistro(){
      this.$refs.Modal.Setear(this.InfoVeris._IdVeris);
      this.VerModal();
    },
    VerModal() {
      this.ModalVisible = true;
      // setTimeout(() => {
      //     this.$refs.Modal.$refs.Valor.focus()
      // }, 200);
    },
    CerrarModal() {
      this.ModalVisible = false;
    },
    EliminarRegistro(_IdRegistro, _IdVeris){
      var _This = this;
      //alert(_Nombre);
      this.$confirm({
        title: "ATENCIÓN",
        message: "Estás seguro de eliminar el registro?",
        button: {
          yes: 'Si',
          no: 'No'
        },
        callback: confirm => {
          if(confirm){
            axios
              .post(_This.urlPosts + "/AgroIdeas/BajaRegistroVeris", {
                IdUsuario: _This.$parent.Datos._User._ID,
                IdRegistro: _IdRegistro
              })
              .then(function (response) {
                _This.$parent.Notificacion("Registro eliminado!", "", "success", 3);
                _This.RefrescarInfo(_IdVeris);
              })
              .catch(function (error) {
                _This.$parent.Notificacion("Error!", "", "error", 3);
                console.error(error);
              })
              .then(function () {
                //console.log("Ok");//LLega siempre que no haya catch
              });
          }
        }
      })
    }
  },
  components: {
    SlidingPagination,
    ModalNuevoRegistroVeris,
    pdf
  },
};
</script>

<style lang="scss" scoped>
@import "../../Css/Globales.css";
@import "../../Css/Componentes.scss";

.svg-inline--fa.fa-w-18, .svg-inline--fa.fa-w-14, .svg-inline--fa.fa-w-16 {
  width: auto !important;
  margin: 0 5px;
}
.c1 {
  width: 40%;
}
.c3 {
  width: 20%;
}
.TituloSeccionFreatimetro {
  line-height: 28px;
  // font-weight: bold;
  padding: 7px 20px;
}

@import "../../Css/Secciones/Tabla.css";

@media only screen and (max-width: 900px) {
  .table-wrapper {
    width: 90%;
    margin: 0 5%;
    overflow-x: scroll;
  }
}
</style>
